export const GoogleMapApiConfig = 'AIzaSyBp-pVwg4Xmb-C2mfEz_VeSLCKC06s8X_U';